import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Alerts } from '../../../components/notify';
import { getBritishDate } from '../../../components/GlobalFunction';
import './certificate.css';
import { API_URL, Currency, FormatNumber, config, UserCode, PKLIVE, FLPKEY, API_IMAGES } from '../../../components/Include';

import { usePaystackPayment } from 'react-paystack';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';

// Define interface for certificate request history item
interface CertificateRequestHistory {
  id: string;
  requestDate: string;
  paymentReference: string;
  skill: string;
  status: 'pending' | 'approved' | 'rejected' | 'ready';
  approvalDate?: string;
  rejectionReason?: string;
}

const CertificateRequest = () => {
  // State management

  const [calculatedAmount, setCalculatedAmount] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [certificateFee] = useState<number>(1000); // Fee for certificate in Naira
  const [certificateHistory, setCertificateHistory] = useState<CertificateRequestHistory[]>([]);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [paymentReference, setPaymentReference] = useState<string>('');
  const [currentSkill, setCurrentSkill] = useState<any>(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState<string>('Paystack');
  const [requestStatus, setRequestStatus] = useState<string>('pending');
  // Get student data from Redux store
  const student = useSelector((state: any) => state.rootReducer.student);




  const handlePaystackFees =()=>{
    var amount = 0
    var amountToCharge = (0.015 * Number(certificateFee)) + 300
if(Number(certificateFee) <2500){

    amount =  (Number(certificateFee)+ (amountToCharge)) * 100

}else if(amountToCharge>2000){
        amount = (Number(certificateFee)+ (2000)) * 100
    }else{
        
    amount =  (Number(certificateFee)+ (amountToCharge+100)) * 100
    }
    return amount;
}


  const handleFlutterwaveFees = () => {
    const amountToCharge = (0.038 * certificateFee);
    const amount = (certificateFee + amountToCharge);
    return amount;
  };
  
  
  let amountToPay = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
  const txRef = (new Date()).getTime().toString();


  const handlePaymentSuccess = ( gateway: string, reference: string) => {

    setLoading(true);
      const fd = new FormData();
     
fd.append('student_code', student.code);
fd.append('transaction_id', txRef);
fd.append('reference', reference);
fd.append('skill_code', currentSkill.skill_code);
fd.append('amount', String(certificateFee)); 
fd.append('gateway', gateway);
fd.append('payment_status', 'paid');  
fd.append('application_code', currentSkill.application_code);


      let url = API_URL+'/student/certificate/request';
        axios.post(url, fd, config).then((response:any)=>{

          if(response.data.status ===200){
            setLoading(false);
      Alerts('success', response.data.message, 'Success')
      fetchCertificateHistory();
      setCurrentStep(2);
      setPaymentReference(reference);

          }else{
            Alerts('danger', response.data.message, 'Something went wrong')
          
          }
        })
        .catch((error)=>{
          Alerts('danger', error.message, 'Error')
          setInterval(()=>{
           // window.location.reload();
          }, 3000)
        }).finally(()=>{
          setLoading(false);
        }) 
      
  };

    
    useEffect(() => {
      const newAmount = activePaymentMethod === 'Paystack' ? handlePaystackFees() : handleFlutterwaveFees();
      setCalculatedAmount(newAmount);
    }, [activePaymentMethod, certificateFee]);
    
    
    useEffect(() => {
      if (calculatedAmount > 0) {
        amountToPay = calculatedAmount;
      }
    }, [calculatedAmount]);
    
   

  const paystackConfig = {
    reference: txRef,
    email: student.email_address,
    firstname:student.full_name + ' '+ student.matric_no,
    lastname:student.telephone,
    phone:UserCode,
    amount: amountToPay,
    publicKey: PKLIVE,
    split_code:'SPL_5Yq0hYZqiv'
    };

  const initializePayment = usePaystackPayment(paystackConfig);
  
    
    const flutterConfig = {
      public_key: FLPKEY,
      tx_ref: txRef,
      amount: amountToPay,
      currency: "NGN",
      country: "NG",
      payment_options: 'card,mobilemoney,ussd',
      customer: {
        email: student.email_address,
        phone_number: UserCode ||"",
        name: student.full_name +  student.telephone + ' '+ student.matric_no,
      },
      customizations: {
        title: 'Entrepreneurship Development Center, NSUK',
        description: 'Change Skill Fee',
        logo: API_IMAGES+'/edc.jpg',
      },
      subaccounts: [
        {
          id: "RS_1A69795ABBEA25EE8B1E73C11688532E",
          transaction_split_ratio: "10"
        },
        {
          id: "RS_BD2F1A4916F6BE96DA7A6118660E4A3F",
          transaction_split_ratio: "10"
        }
      ]
    };
    
    const handleFlutterPayment = useFlutterwave(flutterConfig);
    
    const handleFlutterPay = () => {
      handleFlutterPayment({
        callback: (response) => {
          if (response.status === "successful") {
            handlePaymentSuccess('Flutterwave', String(response.transaction_id));
          } else {
            window.location.reload();
          }
        },
        onClose: () => {
          closePaymentModal();
        },
      });
    };
  
    
    
    const onSuccess = (reference: any) => {
      handlePaymentSuccess('Paystack', reference.reference);
    };
    
    const onClose = () => {
      console.log('Payment closed');
    };
    



  const fetchCurrentSkill = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('student_code', String(UserCode));
      const response = await axios.post(`${API_URL}/student/skill/fetch-current`, fd, config);
   

      if(response.data.status !== 200 && response.data.message== "Skill not found"){
        setCurrentSkill(null);
        Alerts('danger',  'You dont have any active skill', 'No skill found');
        setTimeout(() => {
          
          window.open('/app/dashboard', '_self');
        }, 2000);
      }

      
      if (response.data.status === 200) {
        //skill_code = "Not Yet"
        if(Array.isArray(response.data.data)){
          setCurrentSkill(response.data.data[0]);
        }else{
          setCurrentSkill(null);
        }

      }
    } catch (error: any) {
      Alerts('danger', error.message, 'Error fetching current skill');
    } finally {
      setLoading(false);
    }
  };



  const fetchCertificateHistory = async () => {

    try {
      const fd = new FormData();
      fd.append('student_code', String(UserCode));
    
    const url = API_URL + '/student/certificate/history';

      const response = await  axios.post(url, fd, config)
      if (response.data.status === 200) {

        setCertificateHistory(response.data.data);

      }
  } catch (error: any) {
    Alerts('danger', error.message, 'Error fetching change history');
  } 
}



   useEffect(() => {
    fetchCurrentSkill()
    fetchCertificateHistory();
  }, []);


  // Toggle history view
  const toggleHistory = () => {
    setShowHistory(!showHistory);
  };

  

  // Render step indicator
  const renderStepIndicator = () => {
    return (
      <div className="change-skill-steps">
        <div className={`change-skill-step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
          <div className="change-skill-step-circle">
            {currentStep > 1 ? <i className="fa fa-check"></i> : 1}
          </div>
          <div className="change-skill-step-label">Make Payment</div>
        </div>
        
        
        <div className={`change-skill-step ${currentStep >= 2 ? 'active' : ''}`}>
          <div className="change-skill-step-circle">2</div>
          <div className="change-skill-step-label">Request Status</div>
        </div>
      </div>
    );
  };

  const renderPaymentStep = () => {
    return (
      <div className="change-skill-panel">
        <h5><i className="fa fa-credit-card"></i> Payment for Certificate of Completion</h5>
        
        <div className="certificate-form-group">
          <label>Certificate Fee</label>
          <div className="certificate-fee">
          <div className="payment-amount">
          {Currency}{FormatNumber(certificateFee)}
        </div>
            <p>This fee covers the processing and printing of your certificate.</p>
          </div>
        </div>
        
       
        
        <h6>Select Payment Method</h6>
        
        {/* Payment Methods */}
        <div className="payment-methods">
          <div
            className={`payment-method-card ${activePaymentMethod === 'Paystack' ? 'active' : ''}`}
            onClick={() => setActivePaymentMethod('Paystack')}
          >
            <div className="card-icon">
              <i className="fa fa-credit-card"></i>
            </div>
            <h5>Paystack</h5>
            <p>Pay with card, bank transfer or USSD</p>
          </div>

         
        </div>

        {/* Payment Summary */}
        <div className="payment-summary">
          <div className="summary-item">
            <span>Base Amount:</span>
            <span>
              {Currency}
              {FormatNumber(certificateFee || 0)}
            </span>
          </div>
          <div className="summary-item">
            <span>Processing Fee:</span>
            <span>
              {Currency}
              {activePaymentMethod === 'Paystack'
                ? FormatNumber((amountToPay / 100) - certificateFee)
                : FormatNumber(amountToPay - certificateFee)}
            </span>
          </div>
          <div className="summary-item total">
            <span>Total:</span>
            <span>
              {Currency}
              {activePaymentMethod === 'Paystack'
                ? FormatNumber(amountToPay / 100)
                : FormatNumber(amountToPay)}
            </span>
          </div>
        </div>

        {/* Payment Button */}



{currentSkill&&currentSkill.skill_code === "Not Yet" ? <div className="change-skill-alert mt-5">
          <i className="fa fa-info-circle"></i>
          <p>
            You have not yet completed a skill.
          </p>
        </div>:<div>
       


        <button
            className="payment-button"
            onClick={() => initializePayment({ onSuccess, onClose })}
          >
            <i className="fa fa-lock"></i>
            Pay Now with Paystack
            <span>{Currency}{FormatNumber(amountToPay / 100)}</span>
          </button>
</div>}

{/* <button className="payment-button" onClick={()=>handlePaymentSuccess('Flutterwave', txRef)}>
            <i className="fa fa-lock"></i>
            Pay Now with manual
            <span>{Currency}{FormatNumber(amountToPay)}</span>
          </button> */}
      </div>
    );
  };


 
  // Render request status step
  const renderRequestStatusStep = () => {
    return (
      <div className="certificate-content">
        {showHistory ? (
          renderCertificateHistory()
        ) : (
          <div className="certificate-status">
            <div className="certificate-status-icon">
              <i className="fa fa-certificate"></i>
            </div>
            <h2 className="certificate-status-title">Certificate Request Submitted</h2>
            <p className="certificate-status-message">
              Your certificate request has been submitted successfully. You will be notified when it's ready for collection.
              Please note that you will need to physically collect your certificate from the office once it's ready.
            </p>
            
            <div className="certificate-status-details">
              <div className="certificate-status-detail">
                <span className="detail-label">Request Date:</span>
                <span className="detail-value">{getBritishDate(new Date().toISOString())}</span>
              </div>
              <div className="certificate-status-detail">
                <span className="detail-label">Payment Reference:</span>
                <span className="detail-value">{paymentReference}</span>
              </div>
              <div className="certificate-status-detail">
                <span className="detail-label">Skill:</span>
                <span className="detail-value">{currentSkill?.title}</span>
              </div>
              <div className="certificate-status-detail">
                <span className="detail-label">Status:</span>
                <span className="detail-value">
                  <span className={`history-status status-${requestStatus}`}>
                    {requestStatus.toUpperCase()}
                  </span>
                </span>
              </div>
            </div>

            {certificateHistory.length > 0 && (
              <button 
                className="btn-certificate btn-view-history" 
                onClick={toggleHistory}
              >
                <i className="fa fa-history"></i> View Certificate History
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render certificate history
  const renderCertificateHistory = () => {
    return (
      <div className="certificate-history">
        <div className="certificate-history-header">
          <h3 className="certificate-history-title">Certificate Request History</h3>
          <button 
            className="btn-certificate btn-back" 
            onClick={toggleHistory}
          >
            <i className="fa fa-arrow-left"></i> Back to Status
          </button>
        </div>

        {certificateHistory.length === 0 ? (
          <div className="no-history-message">
            <p>No certificate request history found.</p>
          </div>
        ) : (
          <div className="certificate-history-items">
            {certificateHistory.map(item => (
              <div key={item.id} className="certificate-history-item">
                <div className="certificate-history-item-header">
                  <div className="history-date">{getBritishDate(item.requestDate)}</div>
                  <span className={`history-status status-${item.status}`}>
                    {item.status.toUpperCase()}
                  </span>
                </div>
                
                <div className="certificate-history-details">
                  <div className="certificate-history-skill">
                    <span className="history-label">Skill:</span>
                    <span className="history-value">{item.skill}</span>
                  </div>
                  
                  <div className="certificate-history-reference">
                    <span className="history-label">Reference:</span>
                    <span className="history-value">{item.paymentReference}</span>
                  </div>
                  
                  {item.status === 'rejected' && item.rejectionReason && (
                    <div className="certificate-history-reason">
                      <span className="history-label">Reason:</span>
                      <span className="history-value">{item.rejectionReason}</span>
                    </div>
                  )}
                  
                  {(item.status === 'approved' || item.status === 'ready') && item.approvalDate && (
                    <div className="certificate-history-approval">
                      <span className="history-label">Approved on:</span>
                      <span className="history-value">{getBritishDate(item.approvalDate)}</span>
                    </div>
                  )}

                  {item.status === 'ready' && (
                    <div className="certificate-collection-info">
                      <div className="collection-note">
                        <i className="fa fa-info-circle"></i>
                        <span>Your certificate is ready for collection at the office.</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

 
  return (
    <>
      {loading && (
        <div className="overlay">
          <img src="/images/loader.svg" alt="Loading" />
        </div>
      )}
      
      <div className="certificate-container">
        <div className="certificate-header">
          <h4><i className="fa fa-certificate"></i> Certificate Request</h4>
          
          {/* View History Button for Steps 1 and 2 */}
          {(currentStep === 1) && certificateHistory.length > 0 && (
            <button 
              className="btn-view-history" 
              onClick={() => {
                setShowHistory(true);
                setCurrentStep(2);
              }}
            >
              <i className="fa fa-history"></i> View Certificate History
            </button>
          )}
        </div>
        
        <div className="certificate-content">
          {renderStepIndicator()}
          
          {currentStep === 1 && renderPaymentStep()}
          {currentStep === 2 && renderRequestStatusStep()}
        </div>
      </div>
    </>
  );
};

export default CertificateRequest;
